const maintenancePage = {
  header: 'نعمل على إضافة خصائص جديدة لك',
  description: 'يخضع الموقع حالياً للصيانة المجدولة. سنعود قريباً.',
  callToAction: 'الرجاء معاودة المحاولة في وقت لاحق.',
};

export default maintenancePage;
